import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';

import { Observable } from 'rxjs';
import { Subscription } from 'rxjs';

import { IShipmentFilterShipmentName } from 'app-modules/core/store/models/shipment-filter-shipment-name.interface';
import { IShipmentFilterState } from 'app-modules/core/store/models/shipment-filter-state.interface';
import { ShipmentFilterService } from 'app-modules/core/store/shipment-filter/shipment-filter.service';
import * as cloneDeep from 'lodash';
import { shipmentName } from 'app-modules/core/consts/localization';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-shipment-filter-shipment-name-summary',
    templateUrl: 'shipment-filter-shipment-name-summary.component.html',
    styleUrls: ['shipment-filter-shipment-name-summary.component.css'],
    standalone: true,
    imports: [NgIf]
})
export class ShipmentFilterShipmentNameSummaryComponent {
    @Input() shipmentFilter: IShipmentFilterState;
    @Input() isHugeCustomer: boolean;
    @Output() summaryRemove = new EventEmitter();
    constructor(
        private shipmentFilterService: ShipmentFilterService
    ) { }

    clearSelectedFilter() {
        this.shipmentFilter.shipmentName = null;
        this.shipmentFilterService.changeShipmentFilterWithoutShipmentListUpdate(this.shipmentFilter);
        if (this.summaryRemove) {
            this.summaryRemove.emit({ title: shipmentName, value: this.shipmentFilter.shipmentName });
        }
    }
}


